"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationResultType = void 0;
exports.entityMigrationFactory = entityMigrationFactory;
exports.computeMigrationResultSeverity = computeMigrationResultSeverity;
const MessageResult_1 = require("./MessageResult");
var MigrationResultType;
(function (MigrationResultType) {
    MigrationResultType["PropertyAdded"] = "prop-added";
    MigrationResultType["PropertyModified"] = "prop-modified";
    MigrationResultType["PropertyDeleted"] = "prop-deleted";
    MigrationResultType["ProjectMigration"] = "project-migration";
    MigrationResultType["AltiumProjectTransformation"] = "altium-project-transformation";
    MigrationResultType["ComponentMigrationCollision"] = "component-migration-collision";
    MigrationResultType["ComponentMigration"] = "component-migration";
    MigrationResultType["SignalMigration"] = "signal-migration";
    MigrationResultType["BoundaryMigration"] = "boundary-migration";
    MigrationResultType["ModeMigration"] = "mode-migration";
    MigrationResultType["SigmaModelMigration"] = "model-migration";
    MigrationResultType["GenericMigration"] = "generic-migration";
})(MigrationResultType || (exports.MigrationResultType = MigrationResultType = {}));
function entityMigrationFactory(migrations, migrationType) {
    return (entity) => {
        const migratedEntity = { ...entity };
        const migrationResult = {
            type: migrationType,
            isModified: false,
            entity: migratedEntity,
            message: 'Migrated entity',
            innerResults: [],
        };
        for (const [prop, migrator] of Object.entries(migrations)) {
            const selectedField = entity[prop];
            if (selectedField !== undefined) {
                const fieldMigrationResult = migrator(selectedField);
                if (fieldMigrationResult.isModified) {
                    migrationResult.isModified = true;
                    migrationResult.innerResults.push(fieldMigrationResult);
                    migrationResult.entity[prop] = fieldMigrationResult.entity;
                }
            }
        }
        return migrationResult;
    };
}
function computeMigrationResultSeverity(result) {
    (0, MessageResult_1.computeAggragateMessageResultSeverity)(result);
}
//# sourceMappingURL=Migration.js.map